import { AddSquare } from 'iconsax-react';
import {
  Popover,
  PopoverAnchor,
  PopoverContent,
  PopoverTrigger,
} from '@src/design-system/popover';
import { Button } from '@src/design-system/button';
import { DynamicFilterRow } from '@src/shared/features/views/components/filter-popover-content/dynamic-filters/dynamic-filter-row';

import { useTableViewHelpers } from '@design-system/molecules/ticlick-table/hooks/use-table-view-helpers';

import type { TDynamicFilter } from '@shared/types/dynamic-filter';
import { Badge } from '@src/design-system/badge';
import { useTableStates } from '@src/design-system/molecules/ticlick-table/hooks/use-table-states';

export function SubmissionFilters() {
  const { addDynamicFilter } = useTableViewHelpers();
  const { tableFilters, currentView } = useTableStates();
  const dynamicFilters = tableFilters?.dynamicFilters || [];

  const dynamicFiltersCount = dynamicFilters.length;
  const createdDynamicFiltersCount = currentView?.filters.length;

  const addFilterRowIfNoFilters = () => {
    if (dynamicFiltersCount) return;
    addDynamicFilter({} as TDynamicFilter);
  };

  return (
    <Popover modal>
      <PopoverAnchor>
        <div className='flex flex-col gap-4'>
          <PopoverTrigger asChild>
            <Button
              onClick={addFilterRowIfNoFilters}
              size='sm'
              className='text-[13px] bg-primary-50 [&_svg]:size-4 text-primary-900 border border-dashed border-primary-200 hover:bg-primary-100/70'
            >
              <AddSquare />
              Add filter
              {!!createdDynamicFiltersCount && (
                <Badge className='rounded-full text-[10px] flex justify-center items-center size-4 p-1 font-medium bg-primary-900 text-white'>
                  {createdDynamicFiltersCount}
                </Badge>
              )}
            </Button>
          </PopoverTrigger>
        </div>
      </PopoverAnchor>

      <PopoverContent
        align='end'
        side='top'
        className='absolute top-[-12px] w-fit left-6 space-y-2'
      >
        {dynamicFilters.map((f, index) => {
          return (
            <DynamicFilterRow
              key={f.id}
              dynamicFilter={f}
              position={index}
            />
          );
        })}
        <Button
          size='sm'
          onClick={() => addDynamicFilter({} as TDynamicFilter)}
          className='text-[13px] bg-primary-50 [&_svg]:size-4 text-primary-900 border border-dashed border-primary-200 hover:bg-primary-100/70'
        >
          <AddSquare />
        </Button>
      </PopoverContent>
    </Popover>
  );
}
